export function toggleSearch() {
    jQuery(document).ready(function() {
    
        jQuery(document).on("click", ".fa-search", function() {
    
            jQuery('.search-account__wrapper--mobile').toggleClass('show');
            console.log('here');
            
        });
    });
}




